/*
 * Countdown Bar V3-V6 ortak sayac elementi.
 * Markup:
 *   <countdown-bar-timer data-end="2026-10-02T17:00:00+03:00"
 *     [data-start="2026-09-25T00:00:00+03:00"] [data-link="/url"]>
 *   data-end/data-start: snippets/countdown-bar-iso (magaza saat dilimi offset'li ISO 8601).
 *     [data-unit="days|hours|minutes|seconds"]  -> iki haneli deger yazilir
 *     [data-ring="days|hours|minutes|seconds"]  -> --cb-ratio (0-1) atanir
 *   </countdown-bar-timer>
 * Baslangic tarihi varsa element uzerine --cb-progress (0-1, gecen sure orani) atanir.
 * Sure dolunca icinde bulundugu Shopify section'i gizlenir.
 */
if (!customElements.get("countdown-bar-timer")) {
  const UNIT_MAX = { days: 30, hours: 24, minutes: 60, seconds: 60 };

  class CountdownBarTimer extends HTMLElement {
    connectedCallback() {
      // ISO offset icerdigi icin tarayicinin saat diliminden bagimsiz dogru an.
      this.endDate = new Date(this.dataset.end);
      this.startDate = this.dataset.start ? new Date(this.dataset.start) : null;

      this.unitEls = this.querySelectorAll("[data-unit]");
      this.ringEls = this.querySelectorAll("[data-ring]");

      this.link = this.dataset.link;
      if (this.link) {
        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.addEventListener("click", this.onClick);
        this.addEventListener("keydown", this.onKeydown);
      }

      clearInterval(this.interval);
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      if (this.link) {
        this.removeEventListener("click", this.onClick);
        this.removeEventListener("keydown", this.onKeydown);
      }
    }

    tick() {
      const now = Date.now();
      const diff = this.endDate.getTime() - now;

      if (Number.isNaN(diff) || diff <= 0) {
        clearInterval(this.interval);
        const section = this.closest(".shopify-section");
        if (section) section.style.display = "none";
        return;
      }

      const values = {
        days: Math.floor(diff / 86400000),
        hours: Math.floor((diff % 86400000) / 3600000),
        minutes: Math.floor((diff % 3600000) / 60000),
        seconds: Math.floor((diff % 60000) / 1000),
      };

      this.unitEls.forEach((el) => {
        const text = String(values[el.dataset.unit]).padStart(2, "0");
        if (el.textContent !== text) el.textContent = text;
      });

      this.ringEls.forEach((el) => {
        const unit = el.dataset.ring;
        el.style.setProperty("--cb-ratio", Math.min(values[unit] / UNIT_MAX[unit], 1));
      });

      if (this.startDate) {
        const total = this.endDate.getTime() - this.startDate.getTime();
        const progress = total > 0 ? (now - this.startDate.getTime()) / total : 0;
        this.style.setProperty("--cb-progress", Math.min(Math.max(progress, 0), 1));
      }
    }

    onClick(event) {
      if (event.target.closest("a, button, input, select, textarea, summary")) return;
      window.location.assign(this.link);
    }

    onKeydown(event) {
      if (event.target !== this) return;
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      window.location.assign(this.link);
    }
  }

  customElements.define("countdown-bar-timer", CountdownBarTimer);
}
